// fw SectionLabel — the small uppercase muted heading over a list
// ("Next up", "Work list").

import React from 'react';
import './SectionLabel.css';

export function SectionLabel({ as: Tag = 'h2', className = '', children, ...rest }) {
  return (
    <Tag className={['fw-section-label', className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </Tag>
  );
}

export default SectionLabel;
